import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: true,
    data: [],
    liveCallUpdatesEnabled: false,
    error: null,
}
export const activeDomainCallSlice = createSlice({
    name: 'activeDomainCall',
    initialState,
    reducers: {
        setActiveDomainCallLoading: (state, action) => {
            state.loading = action.payload;
        },
        setLiveCallUpdatesEnabled: (state, action) => {
            state.liveCallUpdatesEnabled = action.payload;
        },
        setActiveDomainCall: (state, action) => {
            state.loading = false;
            state.data = action.payload;

        },
        updateActiveDomainCall: (state, action) => {
            const callData = action.payload;
            const session_id = callData.session_id;
            const remove = callData.remove === 'yes';


            if (remove) {
                // Remove the call with the matching session_id
                state.data = state.data.filter(call => call.session_id !== session_id);
            } else {
                // Add or update active call
                const existingCallIndex = state.data.findIndex(
                    call => call.session_id === session_id
                );

                if (existingCallIndex >= 0) {
                    state.data[existingCallIndex] = {
                        ...state.data[existingCallIndex],
                        ...callData
                    };
                } else {
                    state.data.push(callData);
                }
            }
        },

        resetActiveDomainCall: () => initialState,


    },

});

export const {
    setActiveDomainCallLoading,
    setLiveCallUpdatesEnabled,
    setActiveDomainCall,
    updateActiveDomainCall,
    resetActiveDomainCall
} = activeDomainCallSlice.actions;

export const selectActiveDomainCall = (state) => state.activeDomainCall;
export const selectLiveCallUpdatesEnabled = (state) => state.activeDomainCall.liveCallUpdatesEnabled;
export default activeDomainCallSlice.reducer;